import React, { useEffect } from 'react';
import {    
  Link,  
  useParams,
  useHistory
} from "react-router-dom";

import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container'
import SaveIcon from '@material-ui/icons/Save';
import IconButton from '@material-ui/core/IconButton';
import FlashOn from '@material-ui/icons/FlashOn';
import Home from '@material-ui/icons/Home';
import Alert from '@material-ui/lab/Alert';
import AddCircleIcon from '@material-ui/icons/AddCircle';

//formularios
import Select from '@material-ui/core/Select'
import Button from '@material-ui/core/Button'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import TextField from '@material-ui/core/TextField'

//Component
import AutocompleteCompany from '../../component/Autocomplete/AutocompleteCompany'

//service
import ConnectionService from '../../services/ConnectionsService'

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      marginTop: 20,
    },
    paper: {
      padding: theme.spacing(2),      
      color: theme.palette.text.secondary,
    },    
    formControl: {
      margin: theme.spacing(2),      
    },
    button: {
      margin: theme.spacing(1),
    },
}));


export default (props) => {

    const classes = useStyles();
    const history = useHistory()
    const { id } = useParams()
        
    const [title, setTitle] = React.useState([]);
    const [company, setCompany] = React.useState({"id":"","label":"","socialName":"","identifier":""});
    const [driver, setDriver] = React.useState({});
    const [dbUrl, setDbUrl] = React.useState("");    
    const [dbUsername, setDbUsername] = React.useState("");    
    const [dbPassword, setDbPassword] = React.useState("");
    const [connectionType, setConnectionType] = React.useState([]);
    const [resultTest, setResultTest] = React.useState({
      success: null,
      msg: ''
    })
  
    const getConnectionType = () => {        
      let responseType = ConnectionService.connectionType()
      responseType
      .then((resp) => {                    
        setConnectionType(resp.data?resp.data:[])        
        getConnectionSetup(resp.data);
      })      
      .catch((error) => console.error(error))      
   }

   const getConnectionSetup = (params) => {
      
    if(!id) return
   
    let response = ConnectionService.connectionSetupGet(id)
    response
      .then((resp) => {       
        setTitle(resp.data.description)
        setDbUrl(resp.data.urlConnection)
        setDbUsername(resp.data.username)
        setDbPassword(resp.data.password)
        setCompany(resp.data.company)      

        let item 
        if(resp.data.driverClassName === 'com.mysql.cj.jdbc.Driver'){                                           
          item = params.find(item => item.dbType === "mysql");              
          setDriver(item.dbType)
        } else if(resp.data.driverClassName === 'com.microsoft.sqlserver.jdbc.SQLServerDriver'){                      
          item = params.find(item => item.dbType === "sqlserver");  
          setDriver(item.dbType)            
        }
        
      })
      .catch((error) => {                      
        console.error("error", error)
      })
  }
    
    const handlerTitle = (event) => {            
      setTitle(event.target.value);      
    }

    const handleDriver = (event) => {                  
      let item = connectionType.find(item => item.dbType === event.target.value);  
      setDriver(event.target.value)
      setDbUrl(item.urlConnection)      
    }    

    const handlerDbUrl = (event) => {            
      setDbUrl(event.target.value);      
    }

    const handlerDbUsername = (event) => {            
      setDbUsername(event.target.value);      
    }

    const handlerDbPassword = (event) => {            
      setDbPassword(event.target.value);      
    }

    const handlerExecuteTest = () => {    

      setResultTest({
        success: null,
        msg: ''
      })
      let connection = connectionType.find(item => item.dbType === driver)
      let body = {
        typeDriver: connection.dbType,
        username: dbUsername,
        password: dbPassword,       
        url: dbUrl,
      }

     let response = ConnectionService.test(body)
     response.then((resp) => {       
      setResultTest({
        success: true,
        msg: ''
      })
     }).catch((error) => {            
        setResultTest({
          success: false,
          msg: error.response.data
        })
        console.error("error", error)
      })
    }

    const save = () => {

      let connection = connectionType.find(item => item.dbType === driver)
      let body = {
        id: id,
        description: title,
        driverClassName: connection.driverClassName,
        username: dbUsername,
        password: dbPassword,    
        urlConnection: dbUrl,
        company: company,        
      }

      let respSave = ConnectionService.connectionSetupSave(body)
      respSave
        .then((resp) => {           
          if(!id)      
            history.push(`add/${resp.data.id}`)     
        })
        .catch((error) => {                      
          console.error("error", error)
        })
    }

    const addNewConnector = () => {
      history.push(`/connectors/add/`)    
    }

    useEffect(getConnectionType, [])
    

    return (
      
        <Container className={classes.root} >      
        
          <Grid container spacing={4}>

          <Grid item xs={12} >
            <Breadcrumbs aria-label="breadcrumb">
              <Link color="inherit" to="/"  >
                <Home/>
              </Link>
              <Link color="inherit" to="/connectors" >
                Conectores
              </Link>
              <Typography color="textPrimary">Editar: {title}</Typography>
            </Breadcrumbs>
          </Grid>
          
          <Grid item xs={12} >
            <Paper className={classes.paper} >                            
              <IconButton color="primary" onClick={addNewConnector} ><AddCircleIcon /></IconButton>                                          
              <IconButton color="primary" onClick={save} ><SaveIcon /></IconButton>                                          
            </Paper>
          </Grid>

            <Grid item xs={12} >
              <Paper className={classes.paper} >

                <h2>Informações</h2>                                                             
               
                <Grid item xs={12} className={classes.formControl} >
                    <AutocompleteCompany setAutoCompleteContent={setCompany} value={company} />
                </Grid>              

                <Grid item xs={12} className={classes.formControl} >
                  <TextField               
                    label="Título"
                    fullWidth
                    onChange={handlerTitle}
                    value={title}
                    InputLabelProps={{
                      shrink: true,
                    }}         
                  />
                </Grid>
                
              
              </Paper>
          
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper}>

                <Grid item xs={12} className={classes.formControl} >
                  <h2>Configuração</h2>              
                </Grid>

                <Grid item xs={12} className={classes.formControl} >
                  <InputLabel id="driver-label">Driver</InputLabel>         
                  <Select              
                    labelId="driver-label"
                    label="Driver"
                    fullWidth
                    value={driver}
                    onChange={handleDriver}
                    required
                  >
                    {connectionType.map(conn => <MenuItem key={conn.dbType} value={conn.dbType} >{conn.dbType}</MenuItem>)}                                    
                  </Select>
                </Grid>

                <Grid item xs={12} className={classes.formControl} >
                  <TextField               
                      label="Url"
                      fullWidth   
                      value={dbUrl}
                      onChange={handlerDbUrl}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}                    
                  />
                </Grid>            

                <Grid item xs={12} className={classes.formControl} >  
                  <TextField               
                      label="Usuário"
                      fullWidth
                      value={dbUsername}
                      onChange={handlerDbUsername}
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                  />
                </Grid>

                <Grid item xs={12} className={classes.formControl} >
                  <TextField               
                      label="Senha"
                      fullWidth    
                      value={dbPassword}
                      onChange={handlerDbPassword}
                      InputLabelProps={{
                        shrink: true,
                      }}          
                  />
                </Grid>

                <Grid item xs={12} className={classes.formControl} >
                
                  <Button
                    title="Executar Teste de Conexão" 
                    variant="contained"
                    color="secondary"                  
                    className={classes.button}
                    startIcon={<FlashOn />}
                    onClick={handlerExecuteTest}
                  >
                    Testar Conexão
                  </Button>      
                    {resultTest.success === true ? <Alert severity="success">Conexão realizada com sucesso</Alert> : 
                      resultTest.success === false ? <Alert severity="error">Houve um problema com a conexão! <p>{resultTest.msg}</p></Alert> 
                      : ''
                    }                                        
                </Grid>
                              
              </Paper>
            </Grid>        
          </Grid>                      
        </Container>      
    )

}